import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "product-slide__container"
}
const _hoisted_2 = { class: "product-slide__text" }
const _hoisted_3 = { class: "product-name" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "green-bar" }, null, -1)
const _hoisted_5 = { class: "product-slide__image-container" }
const _hoisted_6 = { class: "product-slide__image-wrapper" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "product-slide__buttons" }
const _hoisted_9 = { class: "segmented-button__label" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "segmented-button__label" }
const _hoisted_12 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_product_popup = _resolveComponent("product-popup")!

  return (this.product)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", _hoisted_3, [
            _createTextVNode(_toDisplayString(this.product.productFamily) + " ", 1),
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(this.product.name), 1)
          ]),
          _createElementVNode("p", null, _toDisplayString(this.product.description), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "hotspots"),
            _createElementVNode("img", {
              class: "product-slide__product-image",
              src: this.product.productImage,
              alt: _ctx.ImageAltText
            }, null, 8, _hoisted_7)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "segmented-button segmented-button--transparent",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.popup.togglePopup()))
          }, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.labelInformation), 1)
          ]),
          _createElementVNode("a", {
            class: "segmented-button segmented-button--full segmented-button--green",
            href: _ctx.orderUrl
          }, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.labelOrder), 1),
            _createElementVNode("span", {
              class: "segmented-button__icon",
              innerHTML: _ctx.ArrowUp
            }, null, 8, _hoisted_12)
          ], 8, _hoisted_10)
        ]),
        _createVNode(_component_product_popup, {
          ref: "popup",
          product: this.product,
          orderUrl: _ctx.orderUrl
        }, null, 8, ["product", "orderUrl"])
      ]))
    : _createCommentVNode("", true)
}